import { FluidComponentDefinition, FluidRowData } from '@lmig/fluid-core';
import { h } from '@stencil/core';

import { FluidComponentFromDefinition } from '../../../common/fluid-component-rendering.components';

interface ExpandableRowProps {
  useRenderer: boolean;
  dataItem: FluidRowData;
  expandableRowTemplate: (
    rowData: FluidRowData
  ) => FluidComponentDefinition | string;
  expanded: boolean;
  runTemplateOnExpansionOnly: boolean;
}
export const ExpandableRowPanel = (props: ExpandableRowProps) => {
  const {
    useRenderer,
    dataItem,
    expandableRowTemplate,
    expanded,
    runTemplateOnExpansionOnly,
  } = props;
  if (runTemplateOnExpansionOnly && !expanded) {
    return;
  } else {
    return useRenderer ? (
      <FluidComponentFromDefinition
        definition={expandableRowTemplate(dataItem) as FluidComponentDefinition}
      />
    ) : (
      <div innerHTML={expandableRowTemplate(dataItem) as string} />
    );
  }
};
